import "./assets/scss/main.scss";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/index";
import axios from "./plugins/axios";
import * as PhilaUI from "@phila/phila-ui";
import mgtVue from "./plugins/mgt-vue";
import notifications from "./plugins/notifications";
import "es6-promise/auto";
import "babel-polyfill";
import {
  ValidationProvider,
  ValidationObserver,
  extend,
  withValidation,
} from "vee-validate/dist/vee-validate.full.esm";
import VCalendar from "v-calendar";
import VueProgressBar from "vue-progressbar";
//import ProgressBar from '@/components/ProgressBar.vue';
// Define the custom phone number validation rule
extend("phone", {
  getMessage: (field) => "The " + field + " must be a valid phone number.",
  validate: (value) => {
    const phoneRegex = /^[0-9]{10,10}$/;
    return phoneRegex.test(value);
  },
});

extend("isImageFile", {
  params: ["target"],
  getMessage: (field) => "The " + field + " must be a valid phone number.",
  validate: (value, { target }) => {
    console.log(target);
    return target;
  },
});

const VeeTextbox = withValidation(PhilaUI.Textbox);
const VeeCheckbox = withValidation(PhilaUI.Checkbox);

Vue.component("VeeTextbox", VeeTextbox);
Vue.component("VeeCheckbox", VeeCheckbox);

Vue.config.productionTip = false;
//register it
Vue.use(PhilaUI, {});
//Vue.use(mgtVue, { store });
Vue.use(notifications, { store });
Vue.use(axios, { store });

Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);

// Register components in your 'main.js'

Vue.use(VCalendar, { componentPrefix: "vc" });
const options = {
  color: "#B8860B",
  failedColor: "#874b4b",
  thickness: "15px",
  transition: { speed: "0.1s", opacity: "0.8s", termination: 300 },
  autoRevert: true,
  autoFinish: false,
  location: "top",
  inverse: false,
};

Vue.use(VueProgressBar, options);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
